import { keys } from 'lodash'
import { clearFields } from '../fields/fields-actions'



export const clearErrors = () => {
    return {
        type: "CLEAR_ERRORS"
    }
}


export const setErrors = (errors) => {
    return {
        type: "SET_ERRORS",
        errors
    }
}


const scrollToErrors = () => (dispatch, getState) => {
	const errors = getState().errors;

    const getTop = (acc, errorId) => {
        errorId = errorId.replace(".", "-");
        if(!window.document.getElementById(errorId)) return acc;
        const errorTop = window.document.getElementById(errorId).getBoundingClientRect().top;
        return acc < errorTop
            ? acc
            : errorTop
    }

    const topPosition = keys(errors).reduce(getTop, Infinity);
    
    if(topPosition < 0){
        window["$"]("body, html").animate({
            scrollTop: "+=" + (topPosition - 60)
        }, 250);
    }
    console.log("Scroll to: " + topPosition)
}


export default {
    scrollToErrors,
    clearErrors,
    setErrors
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/errors/errors-actions.ts